import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=6e432654"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/home/bazzite/Work/awardapplication/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e432654')) {
      api.createRecord('6e432654', component.options)
    } else {
      api.reload('6e432654', component.options)
    }
    module.hot.accept("./Header.vue?vue&type=template&id=6e432654", function () {
      api.rerender('6e432654', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/core/components/Header.vue"
export default component.exports